import React, { useState } from "react";
import { FormGroup, Button, FormFeedback } from "reactstrap";
import { FieldProps } from "formik";
import TimeKeeper from 'react-timekeeper';

import FormikFieldCustomProps from "../field/formikfieldcustomprops";

const TimePicker: React.FC<FormikFieldCustomProps & FieldProps & { changeText?: string }> = ({
  field: { name, value },
  form: { touched, errors, setFieldValue },
  ...props
}) => {
  const [show, setShow] = useState(false);
  return (
    <FormGroup>
      <div className="time-container">
        {

          (value
            ? <Button onClick={() => setShow(true)} className="show-sel-time">
              {value.replace(':', 'h')}
            </Button>
            : <Button className="select-time" onClick={() => setShow(true)}>{props.label}</Button>)
        }
        {
          show
          && <div className="show-time-keeper">
            <TimeKeeper
                hour24Mode
                switchToMinuteOnHourSelect
                doneButton={(timeoutput) => <span
                  onClick={(e) => setShow(false)}
                  className="react-timekeeper__done-button"
                >
                  {props.changeText}
                </span>}
                closeOnMinuteSelect={false}
                onDoneClick={() => setShow(false)}
                time={value ? value : '00:00'}
                onChange={(newTime) => {
                  //  console.log('newTime: ', newTime)
                  setFieldValue(name, `${newTime.hour < 10 ? '0' : ''}${newTime.hour}:${newTime.minute < 10 ? '0' : ''}${newTime.minute}`)
                }}
              />
            </div>
          }
      </div>
      {touched[name] && errors[name] ? (
        <FormFeedback className="invalid-feedback">{errors[name]}</FormFeedback>
      ) : (
          ""
        )}
    </FormGroup>
  );
};

export default TimePicker;
